import React, { useEffect, useState } from "react";
import "./registerForm.css";
import * as Yup from "yup";
import { Field, Form, Formik, useFormikContext } from "formik";
import logoutimg from "../../assets/logout.png";
import ErrorMsg from "../../components/form/errorMsg";
import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import InputCapitalField from "../../components/form/InputCapitalField/InputCapitalField";
import ErrorPopup from "../../components/Popups/ErrorPopup";
import SuccessPopup from "../../components/Popups/SuccessPopUp";

const RegisterDistributionDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(true);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState('');


  const FSSAIregex = /^[0-9]{1}[0-9]{2}[0-9]{2}[0-9]{3}[0-9]{6}$/;
  const GSTregex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const initialValues = {
    firm_name: "",
    drug_licence_number_20_a: "",
    drug_licence_number_20_b: "",
    fssai_number: "",
    gst_number: "",
  };

  const FormEnableCheck = () => {
    const {
      values: {
        firm_name,
        drug_licence_number_20_a,
        drug_licence_number_20_b,
        fssai_number,
        gst_number,
      },
    } = useFormikContext();
    useEffect(() => {
      if (
        firm_name.trim() != "" &&
        drug_licence_number_20_a.trim() != "" && drug_licence_number_20_a != drug_licence_number_20_b &&
        drug_licence_number_20_b.trim() != "" &&
        fssai_number.trim() != "" &&
        gst_number.trim() != ""
      ) {
        setDisable(false);
      } else {
        setDisable(true);
      }
    }, [
      firm_name,
      drug_licence_number_20_a,
      drug_licence_number_20_b,
      fssai_number,
      gst_number,
    ]);
    return null;
  };

  const loginSchema = Yup.object().shape({
    firm_name: Yup.string().trim().required("* Required"),
    drug_licence_number_20_a: Yup.string().trim().required("* Required"),
    drug_licence_number_20_b: Yup.string().notOneOf([Yup.ref("drug_licence_number_20_a")], "Drug Licence 1 & 2 should not be same").required("* Required"),
    fssai_number: Yup.string()
      .max(14, "Invalid!")
      // .matches(FSSAIregex, "Invalid FSSAI Number")
      .trim()
      .required("* Required"),
    gst_number: Yup.string()
      // .matches(GSTregex, "Invalid")
      .trim()
      .required("* Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    // setLoading(true);
    console.log(values);
    navigate("/upload-profile-image", {
      state: values,
    });
  };

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/login");
  }
  const logoutSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    const message = (data.data.message);
    const msg_updated = message.charAt(0).toUpperCase() + message.slice(1);
    setShowSuccessMsg(msg_updated);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  const logoutError = (err) => {
    console.log(err);
    setShowErrorPopup(true)
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return localStorage.getItem("isDetails") == "true" ? (
    <Navigate to="/register-contact-details" />
  ) : (
    <div className="register-main-container  d-flex justify-content-center align-items-center">
      <div className="register-Distribution-form-container col-10 col-md-6 px-2  mx-auto my-2 py-3  ">
        <div className="d-flex justify-content-between px-3 mx-2 mt-3">
          <div>
            <label className="fw_500 fn_Nunito fs_20 fs_md_18 fs_sm_16">
              Distribution Details
            </label>
          </div>
          <div
            className="d-flex align-items-center mb-md-3 cursor_pointer"
            onClick={() => logoutHandler()}
          >
            <span className="fs_12 fs_sm_10  fw_600 color_2ad3e7">Logout</span>
            <img className="mx-1" src={logoutimg} height="12px" />
          </div>
        </div>
        {/* <div className=" px-3 mx-2">
          <p className="fs_11 fs_sm_11 col-9 fn_Nunito color_b0b3c7 ">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Odio semper
            ac laoreet.
          </p>
        </div> */}
        <div className="mt-4">
          <Formik
            initialValues={initialValues}
            validationSchema={loginSchema}
            onSubmit={onSubmit}
          >
            {({ props, setFieldValue, values }) => (
              <Form>
                <FormEnableCheck />
                <div className="">
                  <div className="regform-Distribution-container mx-2 px-3 ">
                    <div className="w-100 ">
                      <label className="w-100 mx-1 fn_Nunito fs_14 ">
                        Firm Name
                      </label>
                      <Field name={"firm_name"}>
                        {({ field, meta }) => (
                          <InputCapitalField
                            setFieldValue={setFieldValue}
                            {...field}
                            placeholder="Enter your firm name"
                            id={"firm_name"}
                            className={"w-100 input-field"}
                            value={values?.firm_name}
                          />
                        )}
                      </Field>
                    </div>
                    <div className="w-100 ">
                      <label className="w-100 mx-1 fn_Nunito fs_14  ">
                        Drug License 1
                      </label>
                      <Field name={"drug_licence_number_20_a"}>
                        {({ field, meta }) => (
                          <input
                            {...field}
                            placeholder="Enter your drug license number 1"
                            id={"drug_licence_number_20_a"}
                            className={"w-100 input-field"}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="drug_licence_number_20_a" />
                    </div>

                    <div className="w-100 mt-">
                      <label className="w-100 mx-1 fn_Nunito  fs_14  ">
                        Drug License 2
                      </label>
                      <Field name={"drug_licence_number_20_b"}>
                        {({ field, meta }) => (
                          <input
                            {...field}
                            placeholder="Enter your drug license number 2"
                            id={"drug_licence_number_20_b"}
                            className={"w-100 input-field"}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="drug_licence_number_20_b" />
                    </div>
                    <div className="w-100 mt-">
                      <label className="w-100 mx-1 fn_Nunito fs_14  ">
                        FSSAI Number
                      </label>
                      <Field name={"fssai_number"}>
                        {({ field, meta }) => (
                          <input
                            {...field}
                            placeholder="Enter your FSSAI number"
                            id={"fssai_number"}
                            className={"w-100 input-field"}
                            onChange={(e) => {
                              const value = e.target.value || "";
                              setFieldValue(
                                "fssai_number",
                                value?.toUpperCase()
                              );
                            }}
                            maxlength={14}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="fssai_number" />
                    </div>
                    <div className="w-100 mt-">
                      <label className="w-100 mx-1 fn_Nunito fs_14  ">
                        GST Number
                      </label>
                      <Field name={"gst_number"}>
                        {({ field, meta }) => (
                          <input
                            {...field}
                            placeholder="Enter your GST number"
                            id={"gst_number"}
                            className={"w-100 input-field"}
                            onChange={(e) => {
                              const value = e.target.value || "";
                              setFieldValue(
                                "gst_number",
                                value?.toUpperCase()
                              );
                            }}
                            maxLength={15}
                          />
                        )}
                      </Field>
                      <ErrorMsg name="gst_number" />
                    </div>
                  </div>
                  <div>
                    <div className="px-3 mx-2">
                      <button
                        type="submit"
                        className="register-button fs_14 fs_sm_12 "
                        disabled={disable}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <ErrorPopup
            show={showErrorPopup}
            title={showErrorMsg}
            handleClose={closeErrorPopup}
          />
          <SuccessPopup
            show={showSuccessPopup}
            title={showSuccessMsg}
          />
        </div>
      </div>
    </div>
  );
};

export default RegisterDistributionDetails;
